/* Project Import will be here */
import { ApiUrl } from './apiUrlv1';
// import { ApiUrl } from './apiUrlv2';
/* Project Import will be here */

export class ApiUrls {
    static Routes = ApiUrl;
}